import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConsultantFormComponent } from 'src/app/WebView/FormWebView/query/consultant-form/consultant-form.component';
import { APISchedulerService } from 'src/services/api-services/api-scheduler-service';
import { HelperService } from 'src/services/helperService';
import { TranslateService } from '@ngx-translate/core';
import { Observable, catchError, tap } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-cancel-appointment',
    templateUrl: './cancel-appointment.component.html',
    styleUrls: ['./cancel-appointment.component.sass'],
    standalone: false
})
export class CancelAppointmentComponent implements OnInit {

   public showMessageNotFound: boolean = false;
   public YourReservationHasNeenCanceled:string=""
   recievedLanguageForCountry:any = history.state.LanguageForCountry as {}
   isDeleting = true;
   indexbrand: string =""
   indexCountry: string =""
Mensage=""
   constructor(
      public dialogRef: MatDialogRef <ConsultantFormComponent>,
      @Inject (MAT_DIALOG_DATA) public appointmentId:any,
      public schedulerService: APISchedulerService, 
      private helperService: HelperService,
      private translate: TranslateService,
      private router: Router,
      private route: ActivatedRoute,private datePipe: DatePipe
   ) 
   {
      
   }
   schedule

   ngOnInit(): void {
      this.evaluateLanguage();
      this.Mensage =  this.translate.instant(  'Loading' );
      this.route.params.subscribe(params => {
          
         this.indexbrand = params['brand'];
         this.indexCountry = params['country'];
       });
   

      this.schedulerService.get(this.appointmentId).pipe (tap((Response)=>{
         this.schedule = Response
         this.isDeleting = false
          this.Mensage =  this.translate.instant(  'Canceling' );
      })).subscribe(
         {
           error: (failed) => {
            const translateTextError = this.translate.instant(
               'notMatchFound'
             );
     
             this.helperService.showAlert =true
            this.helperService.typeAlert ="error"
            this.helperService.messageAlert =translateTextError
            setTimeout(() => {
              this.helperService.showAlert =false
              }, 7000)
     
           },
         })
         this.YourReservationHasNeenCanceled= this.translate.instant('YourReservationHasNeenCanceled'); 
   }

   deleteServiceSchedule() {
      this.isDeleting = true

     this.schedule.sendToHabeasData = this.schedule.sendToHabeasData ? this.schedule.sendToHabeasData :false
      this.schedule.sendToKeyloop =  this.schedule.sendToKeyloop ?  this.schedule.sendToKeyloop : false
      this.schedule.sendToSap =  this.schedule.sendToSap ?  this.schedule.sendToSap : false
      delete this.schedule.dataProcessing;
      if(!this.schedule.representativeId){delete this.schedule.representativeId;}
      
      
      this.schedule.schedulerStatusId=5
      this.schedulerService.put(this.schedule).pipe (tap((Response)=>{this.isDeleting = false; this.showMessageNotFound = true; this.dialogRef.close(Response)}),catchError((error): Observable<any> => {
         if (error.status === 401) { 
            const bannermanagementURL = `WebView/bannerManage/${this.indexbrand}/${this.indexCountry}`;
            this.router.navigate([bannermanagementURL]);
            this.helperService.TokenBooking = '';
          }else{
            console.error('Error:', error);
             this.dialogRef.close()
            const translateTextError = this.translate.instant('CancelFailedMsg');
            this.helperService.showAlert =true
            this.helperService.typeAlert ="error"
            this.helperService.messageAlert =translateTextError
            setTimeout(() => {
              this.helperService.showAlert =false
              }, 7000)
          }
          return error;  
       })).subscribe();
   }
   cancel(){
      this.dialogRef.close()
     }
   evaluateLanguage(): void {
   }
}